import { useTheme } from 'styled-components';

export const useBodyStyles = () => {
  const theme = useTheme();
  return `
    body {
      font-family: "Sofia Pro", system-ui, -apple-system, BlinkMacSystemFont, "Avenir Next", Avenir, "Segoe UI", "Lucida Grande", "Helvetica Neue", Helvetica, "Fira Sans", Roboto, Noto, "Droid Sans", Cantarell, Oxygen, Ubuntu, "Franklin Gothic Medium", "Century Gothic", "Liberation Sans", sans-serif;
      font-size:  16px;
      margin: 15px;
      color: ${theme.colors.textColors.textPrimary};
    }
  `;
};
